/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S4_TitleInputs */

const en_fc_tut_s4_title = /** @type {(inputs: Fc_Tut_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build a rough cut with three-point editing`)
};

/**
* | output |
* | --- |
* | "Build a rough cut with three-point editing" |
*
* @param {Fc_Tut_S4_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s4_title = /** @type {((inputs?: Fc_Tut_S4_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S4_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s4_title(inputs)
});
export { fc_tut_s4_title as "fc.tut.s4.title" }